// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"f3695e0b","136":"84491a69","453":"27b50484","520":"9c8effc7","615":"1085efac","881":"ec2294e6","919":"7c839d64","964":"073d56e7"}[chunkId] + ".chunk.js";
};